<flo-category-list
  [type]="type"
  [adConfigMap]="adConfigMap"
  [categories]="teams$ | async"
  (searchChange)="search($event)"
  (showMoreCategories)="fetchTeams.next()"
></flo-category-list>

